type ProjectPageRouteProps = {
  projectSlug: string
  metricSlug?: string
  ecosystemMetricId?: string
  productId?: string
}

export const getProjectPageRoute = ({
  projectSlug,
  metricSlug,
  ecosystemMetricId,
  productId,
}: ProjectPageRouteProps) => {
  const metricPageRoute = metricSlug ? `/metrics/${metricSlug}` : ""
  const projectPageRoute = `/projects/${projectSlug}`

  if (productId) {
    return `${projectPageRoute}/${productId}${metricPageRoute}`
  }

  if (ecosystemMetricId) {
    return `${projectPageRoute}/ecosystem/${ecosystemMetricId.replace(/_/g, "-")}`
  }

  return `${projectPageRoute}${metricPageRoute}`
}
